export const stripHtmlAndMarkdown = (str: string = ""): string => {
  let text = str;

  // For HTML-wrapped content, convert block elements to newlines before stripping
  if (text?.trimStart().startsWith('<')) {
    text = text
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/(?:p|div|li|h[1-6]|blockquote|tr)>/gi, '\n');
  }

  // Strip all HTML tags (handles inline tags like <a>, <strong> even in non-HTML-wrapped content)
  text = text.replace(/<[^>]+>/g, '');

  // Decode HTML entities
  text = text
    .replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&nbsp;/g, ' ');

  // Strip markdown bold: **text**, __text__
  text = text.replace(/(\*\*|__)(.*?)\1/gs, '$2');
  // Strip markdown italic *text* only — omit _text_ since underscores appear in URLs
  // and would corrupt links like https://example.com/some_path_here
  text = text.replace(/\*(.*?)\*/g, '$1');

  // Convert markdown links: [text](url) → text (url)
  text = text.replace(/\[([^\]]*)\]\(([^)]*)\)/g, '$1 ($2)');

  return text.replace(/\n{3,}/g, '\n\n').trim();
};

export const sanitizeDangerousText = (str: string = ""): string => {
  return str.replace(/[&<>"']/g, function (match) {
    const escape: Record<string, string> = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    };
    return escape[match];
  });
};